import { render } from "./WorkflowNotes.vue?vue&type=template&id=396d8f32"
import script from "./WorkflowNotes.vue?vue&type=script&lang=js"
export * from "./WorkflowNotes.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ions-alpha/Documents/IONS-project/pit-story/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__